<!-- Divider -->
<div
    [ngClass]="item.classes?.wrapper"
    class="fuse-vertical-navigation-item-wrapper divider"
></div>
